import { ModuleWithProviders, NgModule } from '@angular/core';
import { CxDesignVersionProviderDirective } from './cx-design-version/cx-design-version-provider';
import { CX_DESIGN_VERSION_TOKEN, CX_RTL_TOKEN } from './cx-design-version/cx-design-version.config';
import { CxInputDateProviderDirective } from './cx-input-date/cx-input-date-provider';
import {
  CX_INPUT_DATE_FIRST_DAY_OF_WEEK_TOKEN,
  CX_INPUT_DATE_FORMAT_TOKEN,
  CX_INPUT_DATE_LANGUAGE_TOKEN,
  CX_INPUT_DATE_CONTROL_BUTTONS_TOKEN,
  CX_INPUT_DATE_HIDE_RESET_BUTTON_TOKEN,
  CX_INPUT_DATE_LABEL_APPLY_TOKEN,
  CX_INPUT_DATE_LABEL_CANCEL_TOKEN,
} from './cx-input-date/cx-input-date.config';
import { CxInputPropertyBindingDirective } from './cx-input-property-binding';
import { CxInputTimeProviderDirective } from './cx-input-time/cx-input-time-provider';
import { CxUiConfig, CxUiConfigService } from './cx-ui.config.service';
import {
  CX_INPUT_TIME_CONTROL_BUTTONS_TOKEN,
  CX_INPUT_TIME_HIDE_RESET_BUTTON_TOKEN,
  CX_INPUT_TIME_LABEL_APPLY_TOKEN,
  CX_INPUT_TIME_LABEL_CANCEL_TOKEN,
} from './cx-input-time/cx-input-time.config';
import { CxButtonProviderDirective } from './cx-button/cx-button-provider';

@NgModule({
  declarations: [
    CxDesignVersionProviderDirective,
    CxInputDateProviderDirective,
    CxInputTimeProviderDirective,
    CxButtonProviderDirective,
    CxInputPropertyBindingDirective,
  ],
  exports: [
    CxDesignVersionProviderDirective,
    CxInputDateProviderDirective,
    CxInputTimeProviderDirective,
    CxButtonProviderDirective,
    CxInputPropertyBindingDirective,
  ],
  providers: [CxUiConfigService],
})
export class CxUiModule {
  static forRoot(config: Partial<CxUiConfig> = {}): ModuleWithProviders<CxUiModule> {
    return {
      ngModule: CxUiModule,
      providers: [
        { provide: CX_DESIGN_VERSION_TOKEN, useValue: config['designVersion'] || 'v2' },
        { provide: CX_RTL_TOKEN, useValue: config['rtl'] || false },
        { provide: CX_INPUT_DATE_FORMAT_TOKEN, useValue: config['dateFormat'] || 'F j, Y' },
        { provide: CX_INPUT_DATE_LANGUAGE_TOKEN, useValue: config['dateLanguage'] || undefined },
        { provide: CX_INPUT_DATE_FIRST_DAY_OF_WEEK_TOKEN, useValue: config['dateFirstDayOfWeek'] || 0 },
        { provide: CX_INPUT_DATE_FORMAT_TOKEN, useValue: config['timeFormat'] || '24h' },
        { provide: CX_INPUT_DATE_CONTROL_BUTTONS_TOKEN, useValue: config['dateControlButtons'] || false },
        { provide: CX_INPUT_TIME_CONTROL_BUTTONS_TOKEN, useValue: config['timeControlButtons'] || false },
        { provide: CX_INPUT_DATE_HIDE_RESET_BUTTON_TOKEN, useValue: config['dateHideResetButton'] || false },
        { provide: CX_INPUT_TIME_HIDE_RESET_BUTTON_TOKEN, useValue: config['timeHideResetButton'] || false },
        { provide: CX_INPUT_DATE_LABEL_APPLY_TOKEN, useValue: config['labelApply'] || undefined },
        { provide: CX_INPUT_DATE_LABEL_CANCEL_TOKEN, useValue: config['labelCancel'] || undefined },
        { provide: CX_INPUT_TIME_LABEL_APPLY_TOKEN, useValue: config['labelApply'] || undefined },
        { provide: CX_INPUT_TIME_LABEL_CANCEL_TOKEN, useValue: config['labelCancel'] || undefined },
      ],
    };
  }

  static forChild(): ModuleWithProviders<CxUiModule> {
    // For child with non IVY rendering is pretty complicated to make it properly works
    // https://github.com/angular/angular/issues/23609
    // Let skip local module configuration as it is not necessary for now.

    // If there are suggestion for changing Version or any other property, use TOKEN.
    return {
      ngModule: CxUiModule,
    };
  }
}
